













import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class iPhoneXFrame extends Vue {
  scale: number = 1;

  mounted() {
    const screen = document.getElementById('iphone-screen');
    if (screen) {
      screen.onwheel = event => {
        if (
          (screen.scrollTop === screen.scrollHeight - screen.clientHeight &&
            event.deltaY > 0) ||
          (screen.scrollTop === 0 && event.deltaY < 0)
        )
          return false;
      };
    }
  }

  created() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }

  destroyed() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    const value = (window.innerHeight - 150) / 812;
    if (value <= 1) this.scale = value;
  }
}
